import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

interface RtlConfirmationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const RtlConfirmationDialog: React.FC<RtlConfirmationDialogProps> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: '12px',
          minWidth: '360px',
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {t('rtlConfirmTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: theme.palette.text.secondary }}>
          {t('rtlConfirmBody')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '8px 24px 16px' }}>
        <Button
          onClick={onCancel}
          sx={{ textTransform: 'none' }}
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ textTransform: 'none' }}
        >
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RtlConfirmationDialog;
